import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';

import {
  Display,
  Header,
  Content,
  Footer,
  HardwareButtonWrapper,
  Labels
} from 'containers';

import { HeaderText } from 'components';
import { DisplayButton } from 'components/buttons';

class MetersTripStats extends Component {
  constructor(props) {
    super(props);

    const { routes } = this.props.content;
    const { left, center, right } = routes;

    const buttonConfig = {
      center: { destination: center }
    };
    let config;

    if (left || right) {
      config = {
        left: { destination: left },
        right: { destination: right }
      };
    } else {
      config = {
        left: { onClick: this.toggleTrip },
        right: { onClick: this.resetTrip }
      };
    }

    this.state = {
      buttonConfig: { ...buttonConfig, ...config }
    };
  }

  toggleTrip = () => {
    const { id, content, setActive } = this.props;
    const { data } = content;

    const updatedValues = data.map((value) => {
      let returnVal;

      if (value instanceof Array) {
        return value.map((innerValue) => {
          returnVal = { ...innerValue };
          returnVal.invert = !innerValue.invert;

          return returnVal;
        });
      }

      returnVal = { ...value };
      returnVal.invert = !value.invert;

      return returnVal;
    });

    setActive(id, updatedValues);
  };

  resetTrip = () => {
    const { id, content, resetValue } = this.props;
    const { data } = content;

    if (data[0].invert) {
      const updatedValues = data.map((value) => {
        let returnVal;

        if (value instanceof Array) {
          return value.map((innerValue) => {
            returnVal = { ...innerValue };

            if (returnVal.num) {
              returnVal.num = '0.00';
            }

            return returnVal;
          });
        }

        returnVal = { ...value };
        returnVal.num = '0.00';

        return returnVal;
      });

      resetValue(id, updatedValues);
    }
  };

  renderButtons = () => {
    const { content } = this.props;
    const { data } = content;
    const { left, right } = content.routes;

    const tripStatisticsMain = ['icon-xm-left-arrow', 'icon-xm-enter', 'icon-xm-right-arrow'];
    const tripStatisticsInactive = ['icon-xm-play', 'icon-xm-cycle', 'icon-xm-reset'];
    const tripStatisticsActive = ['icon-xm-pause', 'icon-xm-cycle'];

    if (left || right) {
      return tripStatisticsMain.map(icon =>
        <DisplayButton key={uuidv4()} src={icon} />);
    }
    if (data[0].invert) {
      return tripStatisticsInactive.map(icon =>
        <DisplayButton key={uuidv4()} src={icon} />);
    }
    return tripStatisticsActive.map(icon =>
      <DisplayButton key={uuidv4()} src={icon} />);
  }

  render() {
    const { buttonConfig } = this.state;
    const { content } = this.props;
    const { title, data } = content;
    const { left, right } = content.routes;

    return [
      <Display key="display">
        <Header>
          <HeaderText value={title} />
        </Header>
        <Content>
          <Labels values={data} />
        </Content>
        <Footer align={(left || right) || data[0].invert ? '' : 'left'}>
          {this.renderButtons()}
        </Footer>
      </Display>,
      <HardwareButtonWrapper key="buttons" config={buttonConfig} />
    ];
  }
}

MetersTripStats.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    data: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
    ]).isRequired,
    routes: PropTypes.objectOf(PropTypes.string).isRequired
  }).isRequired,
  id: PropTypes.string.isRequired,
  resetValue: PropTypes.func.isRequired,
  setActive: PropTypes.func.isRequired
};

export default MetersTripStats;



// WEBPACK FOOTER //
// ./src/screens/shared/Meters/MetersTripStats/MetersTripStats.js